function initSliderIcons() {
  const sliderElm = document.querySelectorAll(".swiper-slider-icon.swiper-container");

  sliderElm.forEach(function (slider) {
    const swiper = new Swiper(slider, {
      loop: true,
      slidesPerView: 3,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        speed: 1,
      },
      spaceBetween: 20,
    });
  });
}

document.addEventListener("DOMContentLoaded", initSliderIcons);
